module.exports = __webpack_public_path__ + "img/item2.88db9306.jpg";